







































































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import { required } from '@/utils/formValidations'
import { maxLength, validateCuit } from '@/utils/ValidationUtil'
import Magistrado from '@/model/Magistrado'
import InvertedSpanTooltip from '@/components/commons/InvertedSpanTooltip.vue'

@Component({
  components: { InvertedSpanTooltip },
})
export default class FormMagistrados extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }
  private itemsTratamientoSelect: any = ['Dr.', 'Dra.']

  @Prop({ default: true })
  private showAgregar: boolean

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop({ required: true })
  private magistrado!: Magistrado

  @Prop({ default: false, type: Boolean })
  private loading = false

  @Prop({ type: String })
  private errorMessage

  @Prop({ default: false, type: Boolean })
  private error = false

  validateCuit(cuit: string) {
    return validateCuit(cuit)
  }

  private localInstance: Magistrado = this.magistrado

  private formDisabled = false

  private dialog = false

  private valid = true

  private rules = {
    required,
    maxLength50: maxLength(50),
  }

  private show = true

  private async newInstance() {
    await this.$emit('newInstance')
    await this.resetValidation()
    await this.$nextTick(this.openDialog)
  }

  resetValidation() {
    this.$refs.form.resetValidation()
  }
  reset() {
    this.$refs.form.reset()
  }

  onClose() {
    this.dialog = false
    this.$nextTick(this.reset)
  }

  async openDialog() {
    await this.onEntidadChange()
    this.dialog = true
  }

  validate() {
    return this.$refs.form.validate()
  }

  onSave() {
    if (this.validate()) {
      this.$emit('save', this.localInstance)
    }
  }

  @Watch('magistrado')
  private onEntidadChange() {
    if (this.magistrado) {
      this.localInstance = JSON.parse(JSON.stringify(this.magistrado))
    }
  }
}
